import { faSignalStream } from '@fortawesome/pro-regular-svg-icons/faSignalStream'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'

import Button from '@space-core/components/button'
import Icon from '@space-core/components/icon'
import Image from '@space-core/components/image'
import { Actions, Entities } from '@space-core/datahub'

import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import LiveDetails from '../liveDetails'

const Thumb = styled.div`
  height: 5.57rem;
  width: 9.94rem;
  aspect-ratio: 16/9;
`

const Card = styled.div`
  border: solid 1px var(--gray-200);
  border-radius: var(--border-radius-lg);
`

export type SingleLiveCardProps = {
  productName: string
  liveName: string
  liveUrl: string
  smallUrlThumbnail: string
  isLiveOnMF: boolean
}

const SingleLiveCard = ({
  productName,
  liveName,
  liveUrl,
  smallUrlThumbnail,
  isLiveOnMF
}: SingleLiveCardProps) => {
  const { t } = useTranslation()
  const { sendDataHubEvent } = useDataHubEvents()
  const navigate = useNavigate()

  const handleLiveRedirect = () => {
    sendDataHubEvent({
      group: Entities.HOME_LIVE,
      name: Actions.CLICK_LIVE_CARD
    })

    return isLiveOnMF ? navigate(String(liveUrl)) : window.open(liveUrl, '_blank')
  }

  return (
    <Card className='_d-flex _p-2 _cursor-pointer' onClick={handleLiveRedirect}>
      <Thumb className='_mr-3'>
        <Image
          src={smallUrlThumbnail}
          objectFit='cover'
          objectPosition='center'
          className='_w-full _h-full _rounded'
          aria-hidden
        />
      </Thumb>
      <div className='_mr-3 _flex-grow-1'>
        <div className='_d-flex _mt-2'>
          <Icon icon={faSignalStream} className='_text-3 _mr-2 _text-red' />
          <h3 className='_text-2 _font-weight-bold _text-gray-900'>{t('live.card.watch_now')}</h3>
        </div>
        <LiveDetails productName={productName} liveName={liveName} titleClamp={1} />
      </div>
      <div className='_align-self-end _p-2'>
        <Button variation='primary' className='_px-4 _border-0'>
          <Icon icon={faPlay} className='_mr-2' />
          <span>{t('live.card.button')}</span>
        </Button>
      </div>
    </Card>
  )
}

export default SingleLiveCard
